import React from 'react';
import { Crown, Zap, MessageSquareQuote, Newspaper } from 'lucide-react';
import { getBadgeStyle } from '../utils/exclusive';

const ICONS = { Crown, Zap, MessageSquareQuote, Newspaper };

/**
 * Renders the auto-detected badge for an article. Returns null if no
 * keyword matches. Three sizes:
 *   size="sm"  - small chip (admin list, tickers)
 *   size="md"  - card overlay (story cards, carousel)
 *   size="lg"  - hero pill above the article title
 */
const ArticleBadge = ({ article, size = 'md', className = '', testId }) => {
  const style = getBadgeStyle(article);
  if (!style) return null;

  const Icon = ICONS[style.icon] || Crown;
  const label = size === 'sm' ? style.labelShort : style.label;

  const sizeClasses = {
    sm: 'text-[9px] px-1.5 py-0.5 gap-1',
    md: 'text-[9px] md:text-[10px] px-2 py-0.5 gap-1',
    lg: 'text-[10px] md:text-[11px] px-3 py-1 gap-1.5',
  };

  const iconSize = {
    sm: 'h-2.5 w-2.5',
    md: 'h-2.5 w-2.5',
    lg: 'h-3 w-3',
  };

  const styleClass = size === 'lg' ? style.classNameLarge : style.className;

  return (
    <span
      data-testid={testId || `article-badge-${style.kind}`}
      className={`inline-flex items-center rounded-full font-black tracking-[0.25em] uppercase ${sizeClasses[size]} ${styleClass} ${style.pulse ? 'animate-pulse' : ''} ${className}`}
    >
      <Icon className={iconSize[size]} />
      {label}
    </span>
  );
};

export default ArticleBadge;
